export var PromptScope;
(function (PromptScope) {
    PromptScope["Global"] = "Global";
    PromptScope["User"] = "User";
})(PromptScope || (PromptScope = {}));
//# sourceMappingURL=prompt-scope.const.js.map